import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getMessaging } from "firebase/messaging";
import { getAnalytics, isSupported } from "firebase/analytics";

const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyCBh6WTzT1vPDp4c13H8ohCuQc_DYvZfPg",
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "spoken-english-app-91554.firebaseapp.com",
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "spoken-english-app-91554",
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "spoken-english-app-91554.firebasestorage.app",
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "271603019874",
    appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:271603019874:web:905fa46108d223c48f613b",
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-H7EHPNYMMM"
};

// Initialize Firebase App safely (singleton)
const app = getApps().length > 0 ? getApp() : initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const messaging = getMessaging(app);

// Initialize Analytics conditionally
export let analytics = null;
isSupported().then((supported) => {
    if (supported) {
        analytics = getAnalytics(app);
    }
}).catch(() => {
    // Analytics not supported in this environment
});

export default app;
